module.exports = __webpack_public_path__ + "img/down_arrow_pink_icon.2a0764b2.svg";